import { AppBar, Button, Toolbar, Typography, Avatar } from "@material-ui/core";
import makeStyles from "@material-ui/styles/makeStyles";
import * as React from "react";
import { Suspense } from "react";
import { useAuthActions, useUser } from "../hooks/auth";

import {
  home,
  membership,
  overview,
  auth,
  admin,
  code,
} from "../services/routes";
import { PrivateRoute } from "./privateRoute";
import { RedirectUserRoute } from "./redirectUserRoute";
import { Link, Redirect, Route, useLocation } from "react-router-dom";
import { useScrollIntoView } from "../hooks/ui";
import Loader from "./core/loader";

import Code from "../pages/code";
import { CONFIG } from "../config";
import PageWrapper from "./pageWrapper";
const Membership = React.lazy(() => import("../pages/membership"));
const Admin = React.lazy(() => import("../pages/admin"));
const Overview = React.lazy(() => import("../pages/overview"));
const Auth = React.lazy(() => import("../pages/auth"));

const useStyles = makeStyles({
  title: {
    flexGrow: 1,
    "& > a": {
      color: "inherit",
      textDecoration: "none",
    },
    marginLeft: "1em",
  },
});

const isIscrizioniOpen = () => {
  const configBypass = localStorage.getItem("configBypass");
  if (configBypass === "true") {
    return true;
  }
  return CONFIG.IS_ISCRIZIONI_OPEN;
};

const Layout: React.FC<{}> = () => {
  const { logout } = useAuthActions();
  const classes = useStyles();
  const [, , empty] = useUser();
  const location = useLocation();
  const ref = useScrollIntoView<HTMLDivElement>([location]);

  return (
    <>
      <AppBar position="static" ref={ref}>
        <Toolbar>
          <Avatar src="/assets/cngei-logo.png" alt="" />
          <Typography variant="h6" className={classes.title}>
            <Link to={home()}>Bologna CNGEI Iscrizioni</Link>
          </Typography>
          {!empty && (
            <Button onClick={logout} color="inherit">
              Esci
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <main>
        {isIscrizioniOpen() ? (
          <>
            <Route exact path={home()}>
              <Redirect to={overview()} />
            </Route>
            <Route exact path={code()} component={Code} />
            <Suspense fallback={<Loader />}>
              <RedirectUserRoute
                path={auth()}
                component={Auth}
                to={overview()}
              />
              <PrivateRoute path={overview()} component={Overview} />
              <PrivateRoute path={membership()} component={Membership} />
              <PrivateRoute path={admin()} component={Admin} />
            </Suspense>
          </>
        ) : (
          <>
            <PageWrapper>
              <Typography variant="h6" className={classes.title}>
                Le iscrizioni sono chiuse al momento. Apriranno il 1 dicembre
                2025.
              </Typography>
              <Typography variant="h6" className={classes.title}>
                Per qualsiasi necessità di carattere tecnico scrivi a{" "}
                <a href={`mailto:${CONFIG.TECH_SUPPORT_EMAIL}`}>
                  {CONFIG.TECH_SUPPORT_EMAIL}
                </a>
              </Typography>
            </PageWrapper>
          </>
        )}
      </main>
    </>
  );
};

export default Layout;
